<template>
    <ion-page :key="key">
        <base-header :title="costumer?.business_name"></base-header>
        <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                    <ion-title size="large">{{ costumer?.business_name }}</ion-title>
                </ion-toolbar>
            </ion-header>
            <ion-buttons v-if="isOnline" class="ion-padding-horizontal flex justify-end">
                <ion-button fill="clear" @click="openModal">
                    <ion-text color="primary">
                        Modifica
                        <ion-icon :icon="createOutline"></ion-icon>
                    </ion-text>
                </ion-button>
            </ion-buttons>
            <div
                class="ion-padding-horizontal"
                :class="{ 'ion-margin-top-half': isOnline, 'ion-margin-top': !isOnline }">
                <ion-text color="medium">Stato di scadenza</ion-text>
                :
                <span v-if="costumer?.expiration_state">
                    <span :class="`expiration-state ${costumer?.expiration_state}`">
                        {{ expirationStateDisplay(costumer?.expiration_state) }}
                    </span>
                </span>
                <ion-note v-else>
                    <small><em>Nessun intervallo di intervento definito</em></small>
                </ion-note>
                <span v-if="costumer?.expiration_state" class="block">
                    <small>
                        <ion-text color="medium">Ultima ispezione:</ion-text>
                        {{ costumer?.last_inspection_delta }} giorni fa
                    </small>
                </span>
            </div>
            <div class="ion-padding-horizontal ion-margin-top">
                <div class="w-full">
                    <ion-text color="medium">Frequenza di intervento</ion-text>
                    :
                    <span v-if="interventionFrequency">
                        {{ interventionFrequency.description }}
                    </span>
                    <ion-note v-else>
                        <small><em>Nessuna frequenza di intervento definita</em></small>
                    </ion-note>
                </div>
                <div v-if="interventionFrequency">
                    <div>
                        <small>
                            <ion-text color="medium">Interventi annuali</ion-text>
                            : {{ interventionFrequency.year_interventions_amount }}
                        </small>
                    </div>
                    <div>
                        <small>
                            <ion-text color="medium">Estremi intervalli di scadenza</ion-text>
                            : {{ interventionFrequency.recent_inspection_interval }} -
                            {{ interventionFrequency.regular_situation_interval }} -
                            {{ interventionFrequency.expiring_situation_interval }}
                        </small>
                    </div>
                </div>
            </div>
            <div class="ion-padding-horizontal ion-margin-top">
                <ion-text color="medium">Città</ion-text>
                : {{ costumer?.city }}
            </div>
            <div class="ion-padding-horizontal ion-margin-top">
                <ion-text color="medium">Indirizzo</ion-text>
                : {{ costumer?.address }}
            </div>
            <div class="ion-padding-horizontal ion-margin-top-half">
                <map-box
                    v-if="costumer?.latitude && costumer?.longitude"
                    :center="geoLocation!"
                    :fix-zoom="14"
                    :markers-data="mapMarker"></map-box>
                <div v-else class="w-full ion-text-center">
                    <ion-note>
                        <small><em>Mappa non disponibile</em></small>
                    </ion-note>
                </div>
            </div>
            <div v-if="costumer?.email != undefined" class="ion-padding-horizontal ion-margin-top">
                <ion-text color="medium">Indirizzi email</ion-text>
                :
                <ul v-if="costumer.email && costumer?.email.split(', ').length > 0">
                    <li v-for="email in costumer?.email.split(', ')">
                        <a :href="`mailto:${email}`">{{ email }}</a>
                    </li>
                </ul>
                <div v-else class="ion-margin-top-half" style="text-align: center">
                    <ion-note>
                        <small><em>Nessun indirizzo</em></small>
                    </ion-note>
                </div>
            </div>
            <div v-if="costumer?.pest_animals != undefined" class="ion-padding-horizontal ion-margin-top">
                <ion-text color="medium">Animali monitorati</ion-text>
                :
                <ul v-if="costumer && costumer?.pest_animals.length > 0">
                    <li v-for="animal in costumer?.pest_animals">
                        {{ animal }}
                    </li>
                </ul>
                <div v-else class="ion-margin-top-half" style="text-align: center">
                    <ion-note>
                        <small><em>Nessun infestante monitorato</em></small>
                    </ion-note>
                </div>
            </div>
            <div v-if="costumer?.areas != undefined" class="ion-padding-horizontal ion-margin-top">
                <ion-text color="medium">Aree monitorate</ion-text>
                :
                <ul v-if="costumer && costumer?.areas.length > 0">
                    <li v-for="area in costumer?.areas">
                        {{ area }}
                    </li>
                </ul>
                <div v-else class="ion-margin-top-half" style="text-align: center">
                    <ion-note>
                        <small><em>Nessuna area monitorata</em></small>
                    </ion-note>
                </div>
            </div>
            <div class="ion-margin-top ion-padding-horizontal">
                <ion-text color="medium">Mappe</ion-text>
                :
                <div v-if="costumer?.map_file" class="costumer-detail-map-list ion-margin-top">
                    <!-- // @ts-ignore -->
                    <a
                        :class="`costumer-detail-map-list-item ${!isOnline ? 'muted' : ''}`"
                        :href="isOnline ? costumer?.map_file : undefined">
                        <ion-icon size="large" :icon="mapOutline" color="primary"></ion-icon>
                        <ion-text color="primary">
                            {{ costumer?.map_file.substring(costumer?.map_file.lastIndexOf("/") + 1) }}
                        </ion-text>
                    </a>
                </div>
                <div v-else class="w-full" style="text-align: center">
                    <ion-note>
                        <small><em>Nessuna mappa presente</em></small>
                    </ion-note>
                </div>
            </div>
            <ion-card class="">
                <ion-card-header>
                    <div style="display: flex; justify-content: space-between; align-items: center">
                        <ion-card-title>Contratti stipulati</ion-card-title>
                        <ion-button fill="clear" @click="createContract">
                            <ion-icon :style="{ opacity: isOnline ? '1' : '.4' }" :icon="add"></ion-icon>
                        </ion-button>
                    </div>
                </ion-card-header>
                <ion-card-content>
                    <template v-if="!isContractsLoading">
                        <ion-list v-if="contracts.length > 0" class="costumer-detail-contracts-list">
                            <!--                                      @click="router.push({name: 'costumerInspectionForm', params: {inspectionId: inspection.id, costumerId: inspection.costumer}})"-->
                            <ion-item
                                v-for="contract in contracts"
                                @click="
                                    router.push({
                                        name: 'contractDetails',
                                        params: { costumerId: contract.costumer, contractId: contract.id },
                                    })
                                "
                                class="costumer-detail-contracts-list-item ion-activatable ripple-parent">
                                <ion-label>
                                    <ion-text>
                                        <h3 class="costumer-detail-contracts-list-item-contract-title">
                                            {{ dateFormat(contract.date) }}
                                        </h3>
                                    </ion-text>
                                </ion-label>
                                <ion-icon slot="end" :icon="chevronForwardOutline"></ion-icon>
                                <ion-ripple-effect></ion-ripple-effect>
                            </ion-item>
                        </ion-list>
                        <ion-note v-else><em>Nessun contratto con questo cliente</em></ion-note>
                    </template>
                    <template v-else>
                        <div class="w-full flex justify-center items-center">
                            <ion-spinner></ion-spinner>
                        </div>
                    </template>
                </ion-card-content>
            </ion-card>
            <ion-card class="">
                <ion-card-header>
                    <div style="display: flex; justify-content: space-between; align-items: center">
                        <div style="display: flex; align-items: center">
                            <!-- <ion-button fill="clear" @click="loadInspections" :disabled="isInspectionsLoading">
                                <ion-icon :icon="refreshOutline"></ion-icon>
                            </ion-button> -->
                            <div>
                                <ion-card-title>Ispezioni effettuate</ion-card-title>
                                <div v-if="costumer?.last_inspection_date">
                                    <ion-text color="medium">Ultima ispezione</ion-text>
                                    :
                                    <span>
                                        {{ dateFormat(costumer?.last_inspection_date) }}
                                    </span>
                                </div>
                                <ion-text v-if="costumer?.inspections_count" color="medium">
                                    <span>Ispezioni totali: {{ costumer?.inspections_count }}</span>
                                </ion-text>
                            </div>
                        </div>
                        <ion-button fill="clear" @click="createInspection">
                            <ion-icon :icon="add"></ion-icon>
                        </ion-button>
                    </div>
                </ion-card-header>
                <ion-card-content>
                    <template v-if="!isInspectionsLoading">
                        <ion-list v-if="inspections.length > 0" class="costumer-detail-inspections-list">
                            <ion-item
                                v-for="inspection in inspections"
                                class="costumer-detail-inspections-list-item ion-activatable ripple-parent">
                                <ion-button fill="clear" color="primary" slot="start" @click="sendMail(inspection)">
                                    <ion-icon
                                        :icon="mailOutline"
                                        size="large"
                                        slot="icon-only"
                                        color="primary"></ion-icon>
                                </ion-button>
                                <ion-label
                                    @click="
                                        router.push({
                                            name: 'costumerInspectionForm',
                                            params: { inspectionId: inspection.id, costumerId: inspection.costumer },
                                        })
                                    ">
                                    <ion-text>
                                        <h3 class="costumer-detail-inspections-list-item-inspection-title">
                                            {{ dateFormat(inspection.date) }}
                                        </h3>
                                    </ion-text>
                                </ion-label>
                                <ion-icon slot="end" :icon="chevronForwardOutline"></ion-icon>
                                <ion-ripple-effect></ion-ripple-effect>
                            </ion-item>
                        </ion-list>
                        <ion-note v-else><em>Ancora nessuna ispezione registrata per questo cliente</em></ion-note>
                        <div
                            v-if="!isInspectionsLoading && costumer?.inspections_count != inspections.length"
                            style="display: flex; justify-content: center; align-items: center; margin-top: 16px">
                            <ion-button fill="outline" @click="loadInspections" :disabled="isInspectionsLoading">
                                <ion-icon slot="end" :icon="refreshOutline"></ion-icon>
                                <span>Carica meno recenti</span>
                            </ion-button>
                        </div>
                    </template>
                    <template v-else>
                        <div class="w-full flex justify-center items-center">
                            <ion-spinner></ion-spinner>
                        </div>
                    </template>
                </ion-card-content>
            </ion-card>
            <div class="" style="height: 40px"></div>
            <div class="ion-padding-horizontal" style="display: flex; justify-content: end">
                <ion-button fill="clear" color="danger" @click="archiveCustomer" style="">
                    <ion-icon slot="start" :icon="archiveOutline"></ion-icon>
                    Archivia cliente
                </ion-button>
            </div>
            <div class="" style="height: 40px"></div>
            <!--            <ion-fab slot="fixed" vertical="bottom" horizontal="end">
                            <ion-fab-button>
                                <ion-icon :icon="add"></ion-icon>
                            </ion-fab-button>
                            <ion-fab-list side="top">
                                <div class="flex">
                                    <span class="block">Ciao</span>
                                    <ion-fab-button @click="createInspection">
                                        <ion-icon :icon="documentOutline"></ion-icon>
                                    </ion-fab-button>
                                </div>
                                <ion-fab-button >
                                    <ion-icon :icon="readerOutline"></ion-icon>
                                </ion-fab-button>
                            </ion-fab-list>
                        </ion-fab>-->
            <div v-if="deleteLoading" class="delete-loading">
                <ion-spinner name="crescent"></ion-spinner>
            </div>
        </ion-content>
    </ion-page>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import {
    IonButtons,
    IonButton,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonNote,
    IonSpinner,
    IonText,
    IonList,
    IonItem,
    IonLabel,
    IonIcon,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardContent,
    IonRippleEffect,
    IonFabButton,
    IonFab,
    modalController,
    toastController,
    alertController,
} from "@ionic/vue";
import {
    add,
    chevronForwardOutline,
    createOutline,
    mapOutline,
    readerOutline,
    archiveOutline,
    documentOutline,
    refreshOutline,
    mailOutline,
} from "ionicons/icons";
import { useCostumersStore } from "@/stores/costumers";
import { ICostumer } from "@/types/costumer";
import { useInspectionsStore } from "@/stores/inspections";
import { dateFormat } from "@/utility";
import router from "@/router";
import BaseHeader from "@/components/BaseHeader.vue";
import { computed, getCurrentInstance, markRaw, ref } from "vue";
import { useNetworkStore } from "@/stores/network";
import MapBox from "@/components/MapBox.vue";
import { isPlatform } from "@ionic/vue";
import CostumerModal from "@/components/modals/CostumerModal.vue";
import { expirationStateDisplay } from "@/types/intervention_frequency";
import { useInterventionFrequencyStore } from "@/stores/interventionFrequencies";
import LatLngLiteral = google.maps.LatLngLiteral;
import { IExtendedMarkerOptions } from "@/types/maps";
import { useContractsStore } from "@/stores/contracts";
import * as Sentry from "@sentry/vue";
import { IInspection } from "@/types/inspection";

const deleteLoading = ref(false);
const route = useRoute();
const contractsStore = useContractsStore();
const networkStore = useNetworkStore();
const costumersStore = useCostumersStore();
const inspectionsStore = useInspectionsStore();
const interventionFrequenciesStore = useInterventionFrequencyStore();
const { costumerId } = route.params;
const costumer = computed(() => costumersStore.getCustomerById(Number(costumerId)));
const interventionFrequency = computed(() =>
    costumer.value?.intervention_frequency
        ? interventionFrequenciesStore.getInterventionFrequencyById(costumer.value?.intervention_frequency)
        : null,
);
const isOnline = computed(() => networkStore.isOnline);
const key = ref(0);

const isInspectionsLoading = computed(() => inspectionsStore.isLoading);
const inspections = computed(() => inspectionsStore.getInspectionsByCostumerId(Number(costumerId)).reverse());

const sendMailLoadersMap = ref<Map<number, boolean>>(new Map());
const sendMail = async (inspection: IInspection | undefined) => {
    alertController
        .create({
            header: "Confermi di voler inviare l'ispezione via mail?",
            buttons: [
                {
                    text: "Annulla",
                    role: "cancel",
                    cssClass: "archive-text-medium",
                },
                {
                    text: "Invia",
                    role: "confirm",
                    cssClass: "archive-text-primary",
                    handler: () => {
                        sendMailLoadersMap.value.set(inspection?.id || 0, true);
                        inspectionsStore.sendInspectionMail(inspection?.id || 0).then((response) => {
                            if (response.status == 200) {
                                toastController
                                    .create({
                                        message: "Mail inviata correttamente",
                                        duration: 3000,
                                        position: "top",
                                        color: "success",
                                    })
                                    .then((toast) => toast.present());
                            } else {
                                toastController
                                    .create({
                                        message: "Invio mail fallito",
                                        duration: 3000,
                                        position: "top",
                                        color: "danger",
                                    })
                                    .then((toast) => toast.present());
                            }
                            sendMailLoadersMap.value.set(inspection?.id || 0, false);
                        });
                    },
                },
            ],
        })
        .then((alert) => alert.present());
};

const isContractsLoading = computed(() => contractsStore.isLoading);
const contracts = computed(() => contractsStore.getContractsByCostumerId(Number(costumerId)));

const geoLocation = computed(() => {
    if (costumer.value?.latitude && costumer.value?.longitude) {
        return {
            lat: Number(costumer.value?.latitude),
            lng: Number(costumer.value?.longitude),
        } as LatLngLiteral;
    }
    return null;
});

const mapMarker = computed(() => {
    const location = geoLocation.value;
    if (location) {
        return [
            {
                coordinate: location,
                position: {
                    lat: Number(location.lat),
                    lng: Number(location.lng),
                },
                title: costumer.value?.business_name,
            } as IExtendedMarkerOptions,
        ];
    }
    return [];
});

const presentToast = async (message: string) => {
    const toast = await toastController.create({
        message: message,
        duration: 2000,
        position: "bottom",
        color: "danger",
    });

    await toast.present();
};

const openSystemMap = () => {
    if (costumer.value?.latitude && costumer.value?.longitude) {
        if (isPlatform("android")) {
            window.location.href = `geo://${costumer.value?.latitude},${costumer.value?.longitude}`;
        } else {
            window.location.href = `maps://maps.apple.com/?q=${costumer.value?.latitude},${costumer.value?.longitude}`;
        }
    }
};

const createContract = () => {
    if (!isOnline.value) {
        presentToast("Non è possibile creare contratti offline");
    } else {
        router.push({ name: "contractForm", params: { costumerId: costumer.value!.id, contractId: "new" } });
    }
};

const createInspection = () => {
    router.push({ name: "newCostumerInspectionForm", params: { costumerId: costumer.value!.id } });
};

const loadInspections = () => {
    inspectionsStore.loadCustomerInspections(costumer.value!.id);
};

const openModal = async () => {
    const modal = await modalController.create({
        component: CostumerModal,
        componentProps: {
            costumer: markRaw(costumer.value as Object),
        },
    });
    modal.present();

    const result = await modal.onWillDismiss();
    if (result.role === "confirm") {
    }
};

const archiveCustomer = async () => {
    if (!isOnline.value) {
        presentToast("Non è possibile archiviare clienti offline");
        return;
    }
    if (costumer.value) {
        const alert = await alertController.create({
            header: "Confermi di voler archiviare questo cliente?",
            message: "Potrai sempre recuperarlo in seguito, ma non sarà più visibile nella lista dei clienti.",
            buttons: [
                {
                    text: "Annulla",
                    role: "cancel",
                    cssClass: "archive-text-medium",
                },
                {
                    text: "Archivia",
                    role: "destructive",
                    cssClass: "archive-text-danger",
                    handler: async () => {
                        try {
                            await costumersStore.archiveCostumer(costumer.value!.id);
                            toastController
                                .create({
                                    message: "Cliente archiviato con successo",
                                    duration: 1500,
                                    position: "top",
                                    color: "success",
                                })
                                .then((toast) => toast.present());
                            router.push({ name: "costumers" });
                        } catch (error) {
                            console.error("Errore durante l'archiviazione del cliente:", error);
                            presentToast("Errore durante l'archiviazione del cliente");
                            Sentry.captureException(error);
                        }
                    },
                },
            ],
        });

        await alert.present();
    }
};
</script>

<style scoped lang="scss">
.costumer-detail-map-list {
    display: flex;
    flex-wrap: wrap;

    .costumer-detail-map-list-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        margin-right: 16px;
    }
}

.costumer-detail-inspections-list-item,
.costumer-detail-contracts-list-item {
    --padding-start: 0;
    --background: var(--ion-card-background);
}

.costumer-detail-inspections-list-item-inspection-title,
.costumer-detail-contracts-list-item-contract-title {
    font-size: 20px !important;
    font-weight: bold !important;
}

.expiration-state {
    display: inline-block;
    padding: 3px;
    font-weight: bold;
    border-radius: 4px;

    &.recent_inspection {
        background-color: lightskyblue;
    }

    &.regular_situation {
        background-color: green;
    }

    &.expiring_situation {
        background-color: yellow;
        color: var(--ion-background-color);
    }

    &.expired_situation {
        background-color: red;
        color: var(--ion-background-color);
    }
}

.delete-loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
</style>
